import gql from 'graphql-tag';
import { FULL_MOMENT_FRAGMENT } from 'graphql/fragment/momentFragment';

export const CREATE_WORLD_STORY_MUTATION = gql`
    mutation CreateWorldStory(
        $worldMapId: String!
        $storyId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $token: String
    ) {
        createWorldStory(
            worldMapId: $worldMapId
            storyId: $storyId
            story: $story
            cards: $cards
            token: $token
        ) {
            ...FFullMoment
        }
    }
    ${FULL_MOMENT_FRAGMENT}
`;

export const UPDATE_WORLD_STORY_MUTATION = gql`
    mutation UpdateWorldStory(
        $worldMapId: String!
        $storyId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $token: String
    ) {
        updateWorldStory(
            worldMapId: $worldMapId
            storyId: $storyId
            story: $story
            cards: $cards
            token: $token
        ) {
            ...FFullMoment
        }
    }
    ${FULL_MOMENT_FRAGMENT}
`;

export const REMOVE_WORLD_STORY_MUTATION = gql`
    mutation RemoveWorldStory($worldMapId: String!, $storyId: String!, $token: String) {
        removeWorldStory(worldMapId: $worldMapId, storyId: $storyId, token: $token) {
            success
        }
    }
`;
